import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ service }) {
  const Icon = service.icon;
  return (
    <div className="service-card group relative overflow-hidden rounded-2xl">
      {/* Image top */}
      <div className="h-56 w-full overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>
      {/* Overlapping content card */}
      <div className="relative mx-4 -mt-16 rounded-2xl bg-white p-6 shadow-[0_12px_30px_rgba(27,37,69,0.08)]">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-teal-brand text-white">
          <Icon size={22} />
        </div>
        <h3 className="mb-2 text-lg font-bold text-navy-brand">{service.title}</h3>
        <p className="mb-5 text-sm leading-relaxed text-slate-500">{service.short}</p>
        <Link
          to="/services"
          aria-label={`Learn more about ${service.title}`}
          className="arrow-btn flex h-11 w-11 items-center justify-center rounded-full bg-navy-brand text-white"
        >
          <ArrowRight size={18} />
        </Link>
      </div>
      <div className="h-4" />
    </div>
  );
}
